import React from 'react';
import ReactDOM from 'react-dom';
var renderToHTML = function renderToHTML(Component) {
  return new Promise(function (resolve) {
    var span = document.createElement('span');
    ReactDOM.render( /*#__PURE__*/React.createElement(Component, null), span, function () {
      var html = span.innerHTML;
      span.remove();
      resolve(html);
    });
  });
};
export default renderToHTML;